import React, { useState, Fragment } from "react";
import { Sidebar, Tab } from "react-leaflet-sidebarv2";

import SideComment from "./SideComment";
import { SURVEY_OPEN, PHASE_2_MESSAGE, SHOW_OLD_COMMENTS } from "../config";
import "./Sidepanel.css";

function Sidepanel(props) {
    const [collapsed, setCollapsed] = useState(window.innerWidth <= 600);
    const [selected, setSelected] = useState("home");
    const [showOldComments, setShowOldComments] = useState(false);

    let comments = props.comments;

    const open = (id) => {
        if (selected === id && collapsed === false) {
            setCollapsed(true);
        } else {
            setCollapsed(false);
            setSelected(id);
        }
    };

    return (
        <Sidebar
            id="sidebar"
            position="left"
            collapsed={collapsed}
            selected={selected}
            onOpen={(id) => open(id)}
            onClose={() => setCollapsed(true)}
            closeIcon={<img className="close" alt="" src="/icons/close.svg" />}
        >
            <Tab
                id="home"
                header="Home"
                icon={
                    selected !== "home" ? (
                        <img className="home" alt="" src="/icons/home_inactive.svg" />
                    ) : (
                        <img
                            className="home"
                            alt=""
                            src="/icons/home_active.svg"
                        />
                    )
                }
                active
            >
                <div>
                    <h4>Welcome to the Herndon Dream Map!</h4>
                    <p>
                        <b>Do you live, work, worship, play, study, or hang out in Herndon? This map is for you!</b> We want to hear your <b>dreams</b> for Herndon's future. Simply click on the map where it matters most to you, and add a comment!
                    </p>

                    <h4 style={{ marginTop: "20px" }}>How it works:</h4>
                    <p>
                        <b>1. Click on the map</b> where you'd like to share a dream for Herndon.
                    </p>

                    <p style={{ marginTop: "15px" }}>
                        <b>2. Pick a category</b> that describes your dream:
                    </p>
                    <table className="homeTable">
                        <tbody>
                            <tr>
                                <td className="homeIconCell">
                                    <img className="inTextIcon" src="/icons/play_dream.svg" alt="Play" />
                                </td>
                                <td className="homeTextCell">
                                    <b>Play</b> — Recreation, sports, activities, and fun
                                </td>
                            </tr>
                            <tr>
                                <td className="homeIconCell">
                                    <img className="inTextIcon" src="/icons/economy_dream.svg" alt="Economy" />
                                </td>
                                <td className="homeTextCell">
                                    <b>Economy</b> — Businesses, shopping, jobs, and business growth
                                </td>
                            </tr>
                            <tr>
                                <td className="homeIconCell">
                                    <img className="inTextIcon" src="/icons/environment_dream.svg" alt="Environment" />
                                </td>
                                <td className="homeTextCell">
                                    <b>Environment</b> — Parks, nature, green spaces, and sustainability
                                </td>
                            </tr>
                            <tr>
                                <td className="homeIconCell">
                                    <img className="inTextIcon" src="/icons/housing_dream.svg" alt="Housing" />
                                </td>
                                <td className="homeTextCell">
                                    <b>Housing</b> — Homes, neighborhoods, and living spaces
                                </td>
                            </tr>
                            <tr>
                                <td className="homeIconCell">
                                    <img className="inTextIcon" src="/icons/infrastructure_dream.svg" alt="Infrastructure" />
                                </td>
                                <td className="homeTextCell">
                                    <b>Infrastructure</b> — Roads, utilities, and public facilities and services
                                </td>
                            </tr>
                            <tr>
                                <td className="homeIconCell">
                                    <img className="inTextIcon" src="/icons/mobility_dream.svg" alt="Mobility" />
                                </td>
                                <td className="homeTextCell">
                                    <b>Mobility</b> — Biking, walking, driving, metro, and getting around
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <p style={{ marginTop: "20px" }}>
                        <b>3. Add a comment</b> describing your dream, and tell us your name. Then click "Post" to place your pin on the map!
                    </p>
                    <p style={{ marginTop: "10px" }}>
                        You can add as many dreams as you'd like, and you can edit your dreams anytime while the map is open. Please be respectful—everyone can see what you share!
                    </p>
                    <p style={{ marginTop: "10px" }}>
                        Please share this map with family and friends who care about Herndon's future!
                    </p>
                    <p style={{ marginTop: "10px" }}>
                        <i>Reach out to the Town team at<br/>
                        <a href="mailto:herndon2050@herndon-va.gov">herndon2050@herndon-va.gov</a> for Herndon 2050<br/>
                        <a href="mailto:econ@herndon-va.gov">econ@herndon-va.gov</a> for Market Study & Economic Development Strategy</i>
                    </p>
                    {SHOW_OLD_COMMENTS && (
                        <div style={{ marginTop: "20px", paddingTop: "15px", borderTop: "1px solid #ddd" }}>
                            <label style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
                                <input 
                                    type="checkbox" 
                                    checked={showOldComments}
                                    onChange={(e) => {
                                        setShowOldComments(e.target.checked);
                                        if (props.onToggleOldComments) {
                                            props.onToggleOldComments(e.target.checked);
                                        }
                                    }}
                                    style={{ marginRight: "8px" }}
                                />
                                <span>Show Previous Comments (Phase 1)</span>
                            </label>
                        </div>
                    )}
                    {SURVEY_OPEN && (
                        <p style={{ marginTop: "20px" }}>
                            <button
                                className="getStarted button--primary"
                                onClick={() => setCollapsed(true)}
                            >
                                Get Started
                            </button>
                        </p>
                    )}
                </div>
            </Tab>

            <Tab
                id="infoTab"
                header="About the Plan"
                icon={
                    selected !== "infoTab" ? (
                        <img
                            className="info"
                            alt=""
                            src="/icons/about_inactive.svg"
                        />
                    ) : (
                        <img
                            className="info"
                            alt=""
                            src="/icons/about_active.svg"
                        />
                    )
                }
            >
                <p>
                        <img
                            className="Logo center"
                            alt="Herndon_gif"
                            src="/icons/Cycle.gif"
                            width="450"
                        />
                </p>
                <div>
                    <p>
                        The Herndon Dream Map is a community-driven vision for the Town of Herndon. We invite all members of our community to help us understand the current resources, challenges, opportunities, and unique qualities of Herndon so that we can better shape its future.
                    </p>
                    <p>
                        Herndon is a community of residents, workers, business owners, students, and visitors. As a collaborative effort, the Herndon Dream Map will reflect our shared stories, cultures, values, and goals—in other words, our hopes and dreams for Herndon.
                    </p>
                    <p>
                        By adding your own stories, ideas, concerns, and special places to the map, you can participate in shaping this initiative for the future of Herndon.
                    </p>
                    <p>
                        More information about the Herndon Dream Map initiative is available at:{" "}
                    </p>
                    <p>
                        <b>
                            <a
                                target="_blank"
                                rel="noopener noreferrer"
                                href="https://herndon2050.org/"
                            >
                                herndon2050.org
                            </a>
                        </b>
                    </p>
                    
                    <p>
                        Your input matters! Take{" "}
                        <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href="http://www.tinyurl.com/Herndon2050vision"
                        >
                            our other survey
                        </a>
                        {" "}to guide Herndon's growth.
                    </p>
                    
                    <hr style={{ marginTop: "25px", marginBottom: "15px", borderColor: "#CCCCCC" }} />
                    <h4 style={{ fontWeight: "900", marginBottom: "10px" }}><b>Legend</b></h4>
                    <table className="homeTable">
                        <tbody>
                            <tr>
                                <td className="homeIconCell">
                                    <img className="inTextIcon" src="/icons/legend/Herndon Town Boundary.svg" alt="Herndon Town Boundary" style={{ width: "24px", height: "24px" }} />
                                </td>
                                <td className="homeTextCell">
                                    Herndon Town Boundary
                                </td>
                            </tr>
                            <tr>
                                <td className="homeIconCell">
                                    <img className="inTextIcon" src="/icons/legend/Parks.svg" alt="Parks" style={{ width: "24px", height: "24px" }} />
                                </td>
                                <td className="homeTextCell">
                                    Parks
                                </td>
                            </tr>
                            <tr>
                                <td className="homeIconCell">
                                    <img className="inTextIcon" src="/icons/legend/School Zones.svg" alt="School Zones" style={{ width: "24px", height: "24px" }} />
                                </td>
                                <td className="homeTextCell">
                                    School Zones
                                </td>
                            </tr>
                            <tr>
                                <td className="homeIconCell">
                                    <img className="inTextIcon" src="/icons/legend/MetroBus Stations and Route.svg" alt="MetroBus Stations and Route" style={{ width: "24px", height: "24px" }} />
                                </td>
                                <td className="homeTextCell">
                                    MetroBus Stations and Route
                                </td>
                            </tr>
                            <tr>
                                <td className="homeIconCell">
                                    <img className="inTextIcon" src="/icons/legend/Washington & Old Dominion Trail.svg" alt="Washington & Old Dominion Trail" style={{ width: "24px", height: "24px" }} />
                                </td>
                                <td className="homeTextCell">
                                    Washington & Old Dominion Trail
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </Tab>

            <Tab
                id="commentsTab"
                header="Comments"
                icon={
                    selected !== "commentsTab" ? (
                        <img
                            className="comments"
                            alt=""
                            src="/icons/comments_inactive.svg"
                        />
                    ) : (
                        <img
                            className="comments"
                            alt=""
                            src="/icons/comments_active.svg"
                        />
                    )
                }
            >
                {comments &&
                    Object.keys(comments).length > 0 &&
                    Object.keys(comments).map((id) => (
                        <Fragment key={id}>
                            {!comments[id].hidden && props.points[id] && !comments[id].flagged && (showOldComments || comments[id].type === "dreams_2") && (
                                <SideComment
                                    key={id}
                                    comment={{ id: id, ...comments[id] }}
                                    point={props.points[id]}
                                    map={props.map}
                                    latlng={{
                                        lat: props.points[id].lat,
                                        lng: props.points[id].lng,
                                    }}
                                    closePanel={() => setCollapsed(true)}
                                />
                            )}
                        </Fragment>
                    ))}
            </Tab>

            {props.admin && (
                <Tab
                    label="Flagged"
                    icon={
                        !comments || Object.keys(comments).filter(id => comments[id].flagged).length === 0 ?
                        (
                            <img
                                className="flag"
                                alt=""
                                src="/icons/flag_inactive.svg"
                            />
                        ) : (
                            <img
                                className="flag"
                                alt=""
                                src="/icons/flag_active.svg"
                            />
                        )
                    }
                >
                    <div style={{ padding: "15px", fontSize: "0.9em", color: "#666" }}>
                        <strong>Flagged Comments (Admin Only)</strong>
                        <p style={{ marginTop: "10px", fontSize: "0.85em" }}>
                            These comments have been flagged for containing inappropriate language or aggressive content.
                        </p>
                    </div>
                    {comments &&
                        Object.keys(comments).length > 0 &&
                        Object.keys(comments).filter(id => comments[id].flagged).length > 0 ? (
                        Object.keys(comments).map((id) => (
                            <Fragment key={id}>
                                {comments[id].flagged && props.points[id] && (
                                    <div style={{ 
                                        padding: "12px", 
                                        margin: "10px 0", 
                                        border: "2px solid #ff6b6b",
                                        borderRadius: "4px",
                                        backgroundColor: "#ffe0e0"
                                    }}>
                                        <p style={{ margin: "0 0 8px 0", fontWeight: "bold", color: "#c92a2a" }}>
                                            Reason: {comments[id].flagReason || 'unknown'}
                                        </p>
                                        <p style={{ margin: "0 0 8px 0", fontSize: "0.9em" }}>
                                            <strong>{comments[id].commentBy}</strong>
                                        </p>
                                        <p style={{ margin: "0 0 8px 0", fontSize: "0.9em" }}>
                                            {comments[id].comment}
                                        </p>
                                        <button 
                                            onClick={() => props.toggleHidden(id)}
                                            style={{
                                                padding: "6px 12px",
                                                marginRight: "8px",
                                                backgroundColor: "#4CAF50",
                                                color: "white",
                                                border: "none",
                                                borderRadius: "4px",
                                                cursor: "pointer",
                                                fontSize: "0.85em"
                                            }}
                                        >
                                            Hide (Reject)
                                        </button>
                                        <button 
                                            onClick={() => props.unFlagComment && props.unFlagComment(id)}
                                            style={{
                                                padding: "6px 12px",
                                                backgroundColor: "#2196F3",
                                                color: "white",
                                                border: "none",
                                                borderRadius: "4px",
                                                cursor: "pointer",
                                                fontSize: "0.85em"
                                            }}
                                        >
                                            Approve
                                        </button>
                                    </div>
                                )}
                            </Fragment>
                        ))
                    ) : (
                        <div style={{ padding: "15px", textAlign: "center", color: "#999" }}>
                            No flagged comments
                        </div>
                    )}
                </Tab>
            )}
        </Sidebar>
    );
}

export default Sidepanel;
